import React from "react";
import { getProductsByCategory } from "../data/products";
import { PRODUCT_CATEGORIES } from "../data/products";
import "./DedicatedComparison.css";

const dedicated = getProductsByCategory(PRODUCT_CATEGORIES.DEDICATED);

const DedicatedComparison = () => (
  <div className="hn-comparison-wrap">
    <div className="table-responsive">
      <table className="table hn-comparison-table">
        <thead>
          <tr>
            <th>Plan</th>
            <th>V01</th>
            <th>V02</th>
            <th>V03</th>
            <th>V04</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Price</td>
            {dedicated.map((p) => (
              <td key={p.id}><strong>£{Number(p.price).toFixed(2)} / month</strong></td>
            ))}
          </tr>
          <tr>
            <td>CPU</td>
            <td>10 Core</td>
            <td>10 Core</td>
            <td>12 Core</td>
            <td>24 Core</td>
          </tr>
          <tr>
            <td>GPU</td>
            <td>2GB</td>
            <td>2GB</td>
            <td>2GB</td>
            <td>4GB</td>
          </tr>
          <tr>
            <td>Storage</td>
            <td>512GB SSD + 120GB SSD</td>
            <td>512GB NVMe + 120GB SSD</td>
            <td>1TB NVMe + 120GB SSD</td>
            <td>1TB SSD + 120GB SSD</td>
          </tr>
          <tr>
            <td>Network</td>
            <td colSpan="4" className="text-center">40 Mbps · 1TB bandwidth · 97% uptime target</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);

export default DedicatedComparison;
